/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const axiosPayLoad = {
  drugList: [],
  errorPopupMessage: null,
  drugFamily: [],
  removeDrug: [],
  drugSeqNumber: null,
};

const reducer = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.GET_ALL_DRUG_LIST:
      return { ...state, drugList: action.payload };
    case ActionTypes.GET_DRUG_FAMILY:
      return { ...state, drugFamily: action.payload };
    case ActionTypes.REMOVE_DRUG_FROM_LIST:
      return { ...state, removeDrug: action.payload };
    case ActionTypes.VIEW_DRUG_SECTION:
      return { ...state, getDrugDetailsByid: action.payload };
    case ActionTypes.SAVE_DRUG_SEQ:
      return { ...state, drugSeqNumber: action.payload };
    case ActionTypes.LINK_DRUG_FIELDS:
      return { ...state, linkDrugFields: action.payload };
    case ActionTypes.ROW_HIGH_LIGHT:
      return { ...state, rowHighlight: { ...action.payload } };
    case ActionTypes.BUTTON_ENABLE:
      return { ...state, buttonEnableList: { ...action.payload } };
    case ActionTypes.SAVE_DRUGFAMILY_VO:
      return { ...state, savedDrugVo: { ...action.payload } };
    case ActionTypes.SELECT_NDC_PARAM:
      return { ...state, selectedNdc: { ...action.payload } };
      case ActionTypes.VIEW_DRUG_DETAIL_MODAL:
        return { ...state, viewDrugModalDetail: { ...action.payload } };
    default:
      return state;
  }
};

export default reducer;
